<template>
    <div>
        <page-title>商盟编辑</page-title>
        <page-body>
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="公司" prop="org_name">
                    <el-input v-model="form.org_name"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="mobile">
                    <el-input v-model="form.mobile"></el-input>
                </el-form-item>
                <el-form-item label="QQ号" prop="qq_id">
                    <el-input v-model="form.qq_id"></el-input>
                </el-form-item>
                <el-form-item label="微信号" prop="wechat_id">
                    <el-input v-model="form.wechat_id"></el-input>
                </el-form-item>
                <el-form-item label="地区" prop="region">
                    <region-picker v-model="form.region"></region-picker>
                </el-form-item>
                <el-form-item label="营业执照" prop="business_license">
                    <app-upload v-model="form.business_license" :preview="true"></app-upload>
                </el-form-item>
                <el-form-item label="身份证正面" prop="id_card_front">
                    <app-upload v-model="form.id_card_front" :preview="true"></app-upload>
                </el-form-item>
                <el-form-item label="身份证背面" prop="id_card_back">
                    <app-upload v-model="form.id_card_back" :preview="true"></app-upload>
                </el-form-item>
                <el-form-item label="授权凭证" prop="new_icon">
                    <app-upload v-model="form.certificate_url" :preview="true"></app-upload>
                </el-form-item>
                <el-form-item label="等级" prop="level_id">
                    <el-radio-group v-model="form.level_id">
                        <el-radio v-for="(item, index) in levelList"
                                  :key="index"
                                  :label="item.id">{{item.name}}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="证书" prop="license">
                    <app-upload v-model="form.license"></app-upload>
                    <el-image v-if="form.license"
                              fit="scale-down"
                              style="margin-top: 10px; width: 200px;"
                              :src="form.license"></el-image>
                </el-form-item>
                <el-form-item label="修改密码">
                    <el-switch v-model="alterPassword"></el-switch>
                    <el-input v-if="alterPassword" v-model="form.password" placeholder="输入新密码"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="note">
                    <br>
                    <quill-editor :options="editorOption" v-model="form.note"></quill-editor>
                </el-form-item>
                <el-form-item>
                    <el-button @click="submit" type="primary" :loading="submitLoading">保存</el-button>
                </el-form-item>
            </el-form>
        </page-body>
    </div>
</template>

<script>
import axios from '@/axios'
import baseUrl from '@/base-url'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'
import {quillRedefine} from 'vue-quill-editor-upload'
import RegionPicker from '../../../components/RegionPicker'

export default {
    components: {
        RegionPicker,
        quillEditor
    },
    data() {
        return {
            loading: false,
            alterPassword: false,
            form: {
                id: null,
                name: '',
                org_name: '',
                mobile: '',
                qq_id: '',
                wechat_id: '',
                level_id: 0,
                license: '',
                password: '',
                business_license: '',
                id_card_front: '',
                id_card_back: '',
                note: '',
                region: null,
                certificate_url: ''
            },
            rules: {
                name: [
                    {required: true, message: '请填写姓名'}
                ],
                org_name: [
                    {required: true, message: '请填写公司'}
                ],
                mobile: [
                    {required: true, message: '请填写手机号'}
                ],
                level_id: [
                    {required: true, message: '请选择等级'}
                ]
            },
            levelList: [],
            submitLoading: false,
            uploadServer: baseUrl + '/admin/upload/file',
            uploadHeaders: null,
            editorOption: {}
        }
    },
    watch: {
        alterPassword(n) {
            if (!n) {
                this.form.password = ''
            }
        }
    },
    created() {
        this.editorOption = quillRedefine(
            {
                // 图片上传的设置
                uploadConfig: {
                    // 必填参数 图片上传地址
                    action: baseUrl + '/admin/upload/file',
                    header: (xhr, formData) => {
                        xhr.setRequestHeader('Access-Token', this.$store.state.user.access_token)
                    },
                    name: 'file',
                    // 必选参数  res是一个函数，函数接收的response为上传成功时服务器返回的数据
                    // 你必须把返回的数据中所包含的图片地址 return 回去
                    res: (response) => {
                        // 这里切记要return回你的图片地址
                        if (response.code === 0) {
                            return response.data.url
                        }
                    }
                }
            }
        )
        this.uploadHeaders = {
            'Access-Token': this.$store.state.user.access_token
        }
        this.loadLevelList()
        if (this.$route.query.id) {
            this.form.id = this.$route.query.id
            this.loadData()
        }
    },
    methods: {
        loadLevelList() {
            axios({
                url: 'admin/mch/level-list'
            }).then(e => {
                if (e.data.code === 0) {
                    this.levelList = e.data.data
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        loadData() {
            this.loading = true
            this.$request({
                url: 'admin/mch/detail',
                params: {
                    id: this.form.id
                }
            }).then(e => {
                this.loading = false
                if (e.code === 0) {
                    this.form.id = e.data.id
                    this.form.name = e.data.name
                    this.form.org_name = e.data.org_name
                    this.form.mobile = e.data.mobile
                    this.form.qq_id = e.data.qq_id
                    this.form.wechat_id = e.data.wechat_id
                    this.form.level_id = e.data.level_id
                    this.form.license = e.data.license
                    this.form.business_license = e.data.business_license
                    this.form.id_card_front = e.data.id_card_front
                    this.form.id_card_back = e.data.id_card_back
                    this.form.note = e.data.note
                    this.form.region = [e.data.province_id, e.data.city_id, e.data.county_id]
                    this.form.certificate_url = e.data.certificate_url
                } else {
                    this.$message.error(e.msg)
                }
            })
        },
        submit() {
            this.$refs['form'].validate(r => {
                if (r) {
                    this.submitLoading = true
                    axios({
                        url: 'admin/mch/save',
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        if (e.data.code === 0) {
                            this.$message.success('保存成功。')
                            this.$router.replace('/dashboard/admin/mch/index')
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    }).catch()
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
